import React from 'react';

import { t } from 'i18next';

import { ReactComponent as Betterflies } from '../../../../../../../assets/icons/currencies/betterflies-challenge.svg';
import BdsCircleIndicatorPictogram from '../../../../../../../shared/components/v3/BdsCircleIndicator/BdsCircleIndicatorPictogram/BdsCircleIndicatorPictogram';
import BdsCardContainer from '../../../../../../../shared/components/v3/Cards/BdsCardContainer/BdsCardContainer';
import { IChallengeDescriptionPreview } from '../../../../../../../shared/interfaces/challenges';
import { TRANSLATION_CHALLENGES } from '../../../../../../../shared/translations/challenges';
import './ChallengeDescriptionPreview.scss';

const ChallengeDescriptionPreview = ({
  title,
  description,
  rewardsPoints,
  daysLeft,
  circleIndicatorIconUrl
}: IChallengeDescriptionPreview) => {
  const tdaysLeft = t(TRANSLATION_CHALLENGES.detail.daysLeft, { days: daysLeft });

  return (
    <div className="describe-challenge-section-right">
      <BdsCardContainer borderRadiusSize="radius-l" paddingSize="padding-m" className="describe-challenge-preview">
        <div className="p-top">
          <BdsCircleIndicatorPictogram
            className="pt-circle-indicator"
            circleIndicatorSize="m"
            pictogram={{ url: circleIndicatorIconUrl }}
          />
          <div className="pt-text">{tdaysLeft}</div>
        </div>
        <div className="p-center">
          <div className="pc-title">{title}</div>
          <div className="pc-description">{description}</div>
        </div>
        <div className="p-bottom">
          <div className="pb-rewards">{t(TRANSLATION_CHALLENGES.description.rewards)}</div>
          <div className="pb-points">
            <div className="pb-points-text">{`+${rewardsPoints}`}</div>
            <Betterflies className="pb-points-icon" />
          </div>
        </div>
      </BdsCardContainer>
    </div>
  );
};

export default ChallengeDescriptionPreview;
